import React from 'react'
import { StarIcon } from '../../styles/icons'

const TrustPilot = () => (
  <div data-type='trustpilot-container'>
    <div data-type='trustpilot-stars-container'>
      {[1, 2, 3, 4, 5].map((key) => (
        <StarIcon key={`star-${key}`} />
      ))}
    </div>
    <p className='defaultTypographySmall'>Trustpilot Score</p>
  </div>
)

export default TrustPilot
